import React from "react";
import { Tooltip, OverlayTrigger, Badge } from "react-bootstrap";
import "./PublicBlogs.css";
import { connect } from "react-redux";
import { fetchPublicBlog } from "../../actions/publicBlogActions";
import { openSignUpModal } from "../../actions/generalActions";
import history from "../../config/history";

class PublicBlogCard extends React.Component {
  state = {
    isPublicBlogCardHover: false,
    backgroundColor: "rgba(0,0,0,0)",
  };

  setisPublicBlogCardHover = (val) => {
    this.setState({ isPublicBlogCardHover: val });
  };

  render() {
    return (
      <div className="card-container-custom">
        <div
          className={"publicBlogs-card-container"}
          onMouseEnter={() => this.setisPublicBlogCardHover(true)}
          onMouseLeave={() => this.setisPublicBlogCardHover(false)}
          onClick={() => history.push(`/blogs/blog/${this.props.publicBlog._id}`)}
        >
          <img
            className="publicBlogs-card-img"
            src={this.props.publicBlog.thumbnailLink}
            alt={`thumbnail for ${this.props.publicBlog.title}`}
            onLoad={this.props.imgOnLoad}
            width="1200"
            height="700"
          />
          {/* <Fade duration={400} when={this.state.isPublicBlogCardHover} bottom> */}
          <div className={this.props.isSpecial ?" publicBlogs-card-overlay-special" : "publicBlogs-card-overlay"}>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={(props, title = this.props.publicBlog.title) => (
                <Tooltip id="button-tooltip" {...props}>
                  {title}
                </Tooltip>
              )}
            >
              <div className="publicBlog-card-overlay-content">
                <div className="publicBlog-card-play-button-container">
                  <i className="fas fa-book"></i>
                </div>
                <div className="publicBlogs-card-overlay-text">
                  <div className="publicBlogs-card-overlay-text-heading">
                    {this.props.publicBlog.title}
                  </div>
                </div>
              </div>
            </OverlayTrigger>
          </div>
          {/* </Fade> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    publicBlogLink: state.publicBlogs.publicBlogLink,
    error: state.publicBlogs?.error,
    userStatus: state.userLoggedinAndPremiumCheck,
  };
};

export default connect(mapStateToProps, { fetchPublicBlog, openSignUpModal })(
  PublicBlogCard
);
